
  import classNames from 'classnames'
  import type { ShapeComponentType } from '../types'

  export const Blob06:ShapeComponentType = ({ className, ...props }) => {
    return <svg className={classNames('pintxo-shape', className)} {...props} width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M67.1411 0.0220072C85.7969 0.152373 106.346 0.128048 118.362 16.1486C130.638 32.5162 129.301 55.9858 124.683 76.7441C120.205 96.8726 111.132 116.771 94.1524 124.964C77.818 132.845 60.3461 123.826 44.1458 115.603C27.1991 107.001 8.40956 98.3767 2.6559 78.5231C-3.59022 56.9702 1.42734 32.0892 15.1145 15.4271C27.9063 -0.144951 48.2718 -0.109851 67.1411 0.0220072Z" fill="#0C0D0D"/>
</svg>

  }
  
